// eslint-disable-next-line no-shadow
export enum MetricsEvent {
  FORM_ENTRY_OPEN = 'FORM_ENTRY_OPEN',
  FORM_ENTRY_START = 'FORM_ENTRY_START',
  FORM_ENTRY_SUBMIT = 'FORM_ENTRY_SUBMIT',
  FORM_ENTRY_SAVE = 'FORM_ENTRY_SAVE',
  FORM_ENTRY_CLOSE = 'FORM_ENTRY_CLOSE',
  FORM_ENTRY_HIDDEN = 'FORM_ENTRY_HIDDEN',
  FORM_ENTRY_VISIBLE = 'FORM_ENTRY_VISIBLE',
}
